var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mb-5",attrs:{"loading":""}},[_c('div',{staticClass:"py-15 px-4"},[_vm._v(" App is loading... ")])])}
var staticRenderFns = []

export { render, staticRenderFns }